module.exports = __webpack_public_path__ + "img/gardenscapes.0b6330bc.jpg";